import React, { useEffect, useState } from "react";
import Modal from "@material-ui/core/Modal";
import "../styles/CategoryList.css";
import CategoryDataService from "../../services/CategoryService";
import { TextField } from "@material-ui/core";

const GroupsModal = ({ open, onClose, domainName, domainId }) => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    //get groups
    CategoryDataService.getAllCategoryGroupsInDomain(domainId)
      .then((response) => {
        setGroups(response.data);
      })
      .catch((e) => console.log(e));
  }, [open]);
  return (
    <Modal open={open} onClose={onClose} className="add-modal">
      <div className="add-modal-content">
        <div style={{ fontSize: "1.3rem", fontWeight: "600" }}>
          Category Groups in {domainName}
        </div>
        {groups.map((g, i) => {
          return <GroupEditor group={g} key={i} />;
        })}
      </div>
    </Modal>
  );
};

export default GroupsModal;

const GroupEditor = ({ group }) => {
  const [editMode, setEditMode] = useState(false);

  const [localGroup, setLocalGroup] = useState(group);

  const submit = () => {
    CategoryDataService.updateCategoryGroup({
      name: localGroup.name,
      id: localGroup.id,
    })
      .then((response) => {
        console.log("updated category group!");
      })
      .catch((e) => {
        console.log("erro updating group: ", e);
      });
    setEditMode(false);
  };

  const deleteGroup = () => {
    CategoryDataService.deleteCategoryGroup(localGroup.id)
      .then((response) => {
        console.log("deleted category group");
        window.location.reload(false);
      })
      .catch((e) => {
        console.log("error deleting category group: ", e);
      });
  };

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        height: "100%",
        alignItems: "center",
      }}
    >
      {editMode ? (
        <TextField
          id="outlined-basic"
          defaultValue={localGroup.name}
          label="Name"
          variant="filled"
          name="name"
          onChange={(e) =>
            setLocalGroup({ ...localGroup, name: e.target.value })
          }
          fullWidth
        />
      ) : (
        <div>{localGroup.name}</div>
      )}
      <div style={{ display: "flex" }}>
        {editMode ? (
          <div
            style={{
              padding: "0.5rem",
              margin: "0.5rem",
              borderRadius: "0.3rem",
              color: "white",
              backgroundColor: "#43cc6c",
              cursor: "pointer",
            }}
            onClick={submit}
          >
            Done
          </div>
        ) : (
          <div
            style={{
              padding: "0.5rem",
              margin: "0.5rem",
              borderRadius: "0.3rem",
              color: "white",
              backgroundColor: "#3489eb",
              cursor: "pointer",
            }}
            onClick={() => setEditMode(true)}
          >
            Edit
          </div>
        )}
        <div
          style={{
            padding: "0.5rem",
            margin: "0.5rem",
            color: "white",
            backgroundColor: "#eb4664",
            borderRadius: "0.3rem",
            cursor: "pointer",
          }}
          onClick={deleteGroup}
        >
          Delete
        </div>
      </div>
    </div>
  );
};
